import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SortDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const sortOptions = [
    { value: 'relevance', label: 'Best Match', icon: 'Target' },
    { value: 'price-low', label: 'Price: Low to High', icon: 'ArrowUp' },
    { value: 'price-high', label: 'Price: High to Low', icon: 'ArrowDown' },
    { value: 'newest', label: 'Newest First', icon: 'Clock' },
    { value: 'oldest', label: 'Oldest First', icon: 'History' },
    { value: 'quantity', label: 'Most Available', icon: 'Package' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOptionSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  const currentOption = sortOptions.find(option => option.value === value) || sortOptions[0];

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-surface border border-border rounded-md
                 text-sm font-medium hover:bg-secondary-100 transition-all duration-200 ease-out
                 focus:border-border-focus focus:ring-1 focus:ring-primary-500"
      >
        <Icon name={currentOption.icon} size={16} />
        <span>Sort: {currentOption.label}</span>
        <Icon 
          name="ChevronDown" 
          size={16} 
          className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {isOpen && (
        <div className="absolute top-full mt-1 right-0 w-56 bg-surface rounded-md shadow-elevation-3 
                      border border-border z-dropdown">
          <div className="py-1">
            {sortOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => handleOptionSelect(option.value)}
                className={`w-full text-left px-4 py-2 text-sm transition-colors duration-200 
                           flex items-center space-x-3 ${
                             option.value === value
                               ? 'bg-primary-50 text-primary' :'text-text-primary hover:bg-secondary-100'
                           }`}
              >
                <Icon name={option.icon} size={16} />
                <span>{option.label}</span>
                {option.value === value && (
                  <Icon name="Check" size={16} className="ml-auto" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SortDropdown;